import axios from "axios";

export const getSerialNumber = async () => {
    let response = await axios.post(`api/items/get-serial-number`);
    return response.data.data || [];
}

export const addSerialNumber = async (payload) => {
    let response = await axios.post(`api/items/add-serial-outbound`, payload);
    return response.data || [];
}